<script setup lang="ts">
import AuditNavigationToolbar from '@/modules/audits/components/AuditNavigationToolbar.vue'
</script>

<template>
  <div class="d-flex flex-column gap-4">
    <AuditNavigationToolbar />
    <RouterView />
  </div>
</template>
